import {
  Button,
  ExportIcon,
  Heading,
  Pagination,
  Pane,
  Position,
  Spinner,
  StatusIndicator,
  Strong,
  Table,
  Text,
  TickCircleIcon,
  Tooltip,
  CaretDownIcon,
  CaretUpIcon,
  IconButton
} from "evergreen-ui";
import React, { useEffect, useState } from "react";
import CustomizedPagination from "../CustomizedPagination";

export default function EventBookingsTable({
  eventBookingList,
  downloadBookings,
  handleGetBookingDetails,
  currentPage,
  totalPages,
  handlePageChange,
  bookingLoader,
  dispatch,
  bookingDetails,
  filterEventBookingList
}) {
  useEffect(() => {
    if (bookingDetails) {
      for (const eventBooking of eventBookingList) {
        for (const bookingDetail of bookingDetails.bookingDetails) {
          // Check if bookingId and dateBooked match
          if (
            eventBooking.bookingId === bookingDetail.bookingId &&
            eventBooking.dateBooked === bookingDetail.dateBooked
          ) {
            // Update eventBooking with bookingDetail
            Object.assign(eventBooking, bookingDetail);
          }
        }
      }
    }
  }, [bookingDetails]);

  const [sortBy, setSortBy] = useState("bookingId");
  const [sortOrder, setSortOrder] = useState("asc");



  const handleSort = (key) => {
    if (sortBy === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
      filterEventBookingList(key, sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(key);
      filterEventBookingList(key, "asc");
      setSortOrder("asc");
    }
  };

  const renderSortIcon = (key) => {
    if (sortBy !== key) return null;
    return sortOrder === "asc" ? (
      <CaretUpIcon size={12} marginLeft={4} />
    ) : (
      <CaretDownIcon size={12} marginLeft={4} />
    );
  };


  return (
    <Pane
      display={"flex"}
      flexDirection={"column"}
      alignItems={"center"}
      justifyContent={"space-between"}
      width={"100%"}
    >
      <Pane
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        width={"100%"}
        marginTop={20}
      >
        <Heading size={500}>Registration</Heading>
        <Button
          onClick={() => downloadBookings()}
          marginY={8}
          marginRight={12}
          iconBefore={ExportIcon}
        >
          Export
        </Button>
      </Pane>

      <Table
        minWidth={800}
        overflow={"scroll"}
        width={"100%"}
        marginTop={20}
        marginBottom={20}
      >
        <Table.Head>
        <Table.TextHeaderCell
          onClick={() => handleSort("bookingId")}
          cursor="pointer"
        >
          Booking Id {renderSortIcon("bookingId")}
        </Table.TextHeaderCell>

        <Table.TextHeaderCell
          onClick={() => handleSort("bookingDate")}
          cursor="pointer"
        >
          Booking Date {renderSortIcon("bookingDate")}
        </Table.TextHeaderCell>

        <Table.TextHeaderCell
          onClick={() => handleSort("name")}
          cursor="pointer"
        >
          Name / Mobile No. {renderSortIcon("name")}
        </Table.TextHeaderCell>

        <Table.TextHeaderCell>Email</Table.TextHeaderCell>
        <Table.TextHeaderCell>Tickets / Source</Table.TextHeaderCell>
        <Table.TextHeaderCell>Total / PAID</Table.TextHeaderCell>
        <Table.TextHeaderCell>Sub Category</Table.TextHeaderCell>
      </Table.Head>
        {bookingLoader ? (
          <Pane
            display="flex"
            alignItems="center"
            justifyContent="center"
            height={320}
          >
            <Spinner />
          </Pane>
        ) : (
          <Table.VirtualBody height={310}>
            {eventBookingList.map((data) => (
              <Table.Row key={`${data.bookingId}-${data.dateBooked}-${data.startTime}`}>
                <Table.TextCell
                  cursor={"pointer"}
                  onClick={() => {
                    const bookingDetails = {
                      bookingDetails: [data],
                    };
                    dispatch({
                      type: "SET_BOOKING_DETAILS",
                      payload: bookingDetails,
                    });
                    handleGetBookingDetails(data.bookingId, true, true);
                  }}
                >
                  {" "}
                  <Strong textDecoration={"underline"}>
                    {" "}
                    {data?.bookingId}
                  </Strong>
                  {/* <Tooltip
                    isShown={data.checkinData === null ? false : undefined}
                    content={
                      <Pane
                        display="flex"
                        alignItems="center"
                        color="white"
                        flexDirection={"column"}
                      >
                        {data.checkinData === null ? null : (
                          <Pane display="flex" flexDirection="column" gap={4}>
                            <strong size={200}>Checked by:</strong>
                            <Text color="white">
                              {" "}
                              {data?.checkinData?.handler}
                            </Text>

                            <strong size={200}>Time:</strong>
                            <Text color="white">
                              {" "}
                              {data?.checkinData?.timestamp}
                            </Text>
                          </Pane>
                        )}
                      </Pane>
                    }
                    position={Position.TOP}
                  >
                    <Pane
                      display={"flex"}
                      alignItems={"center"}
                      flexDirection={"row"}
                    >
                      {data.checkinData === null ? null : (
                        <TickCircleIcon
                          color="success"
                          marginRight={6}
                          size={16}
                        />
                      )}
                      <Strong textDecoration={"underline"}>
                        {" "}
                        {data?.bookingId}
                      </Strong>
                    </Pane>
                  </Tooltip> */}
                </Table.TextCell>
                <Table.TextCell width={60}>{data?.dateBooked}</Table.TextCell>
                <Table.TextCell>
                  <Pane>{data?.customerDetails?.customerName} / </Pane>
                  <Pane>{data?.customerDetails?.customerMobile}</Pane>
                </Table.TextCell>
                <Table.TextCell>
                  {data?.customerDetails?.customerEmail}
                </Table.TextCell>
                <Table.TextCell width={60}> {data?.slotCount}</Table.TextCell>
                <Table.TextCell width={250} overflow={"visible"}>
                  {" "}
                  {data?.summary?.gross} / {data?.summary?.advance}
                </Table.TextCell>
                <Table.TextCell>
                  {data?.subCategory ? data?.subCategory : "N/A"}
                </Table.TextCell>
              </Table.Row>
            ))}
          </Table.VirtualBody>
        )}
      </Table>
      <Pane
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"end"}
        width={"100%"}
      >
        <CustomizedPagination
          currentPage={currentPage}
          totalPages={totalPages}
          handlePageChange={handlePageChange}
        />
      </Pane>
    </Pane>
  );
}
